<template>
  <div class="card floating">
    <div class="card-title">
      <h2>{{ title }}</h2>
    </div>

    <div class="card-content">
      <p>{{ message }}</p>
      <input class="input input--block" v-focus type="text" @keyup.enter="submit" v-model.trim="name" :placeholder="placeholder">
    </div>

    <div class="card-action">
      <button
        class="button button--flat button--grey" id="buttonCancelNewFile"
        @click="$store.commit('closeHovers')"
        :aria-label="$t('buttons.cancel')"
        :title="$t('buttons.cancel')"
      >{{ $t('buttons.cancel') }}</button>
      <button
        class="button button--flat" id="buttonNewFile"
        @click="submit"
        :aria-label="$t('buttons.create')"
        :title="$t('buttons.create')"
      >{{ $t('buttons.create') }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { files as api } from '@/api';
import { ROUTES } from '@/router';

export default {
  name: 'new-file',
  data () {
    return {
      name: '',
    };
  },
  computed: {
    ...mapGetters(['isFiles', 'isListing']),
    ...mapState(['req', 'showData']),
    fileType () {
      return (this.showData && this.showData.fileType) || 'txt';
    },
    extension () {
      return this.fileType === 'xlsx' ? '.xlsx'
           : this.fileType === 'docx' ? '.docx'
           : '';
    },
    title () {
      if (this.fileType === 'xlsx') return this.$t('prompts.newSheet') || 'Nueva hoja de cálculo';
      if (this.fileType === 'docx') return this.$t('prompts.newDoc') || 'Nuevo documento';
      return this.$t('prompts.newFile');
    },
    message () {
      if (this.fileType === 'xlsx') return this.$t('prompts.newSheetMessage') || 'Nombre de la hoja de cálculo';
      if (this.fileType === 'docx') return this.$t('prompts.newDocMessage') || 'Nombre del documento';
      return this.$t('prompts.newFileMessage');
    },
    placeholder () {
      if (this.fileType === 'xlsx') return 'Hoja sin título.xlsx';
      if (this.fileType === 'docx') return 'Documento sin título.docx';
      return '';
    },
  },
  methods: {
    finalName () {
      let n = this.name;
      if (this.extension && !n.toLowerCase().endsWith(this.extension)) {
        n += this.extension;
      }
      return n;
    },
    async submit (event) {
      event.preventDefault();
      if (this.name === '') return;

      document.getElementById('buttonNewFile').disabled = true;
      document.getElementById('buttonCancelNewFile').disabled = true;

      try {
        const finalName = this.finalName();
        const ibbInstance = this.$route.name === ROUTES.DRIVE ? ibbLink : ibb;
        let handle;

        if (this.fileType === 'xlsx') {
          const { createEmptyXlsxBytes } = await import(/* webpackChunkName: "empty-files" */ '@/utils/emptyFiles');
          handle = await api.createFileWithContent(this.req.handle, finalName, createEmptyXlsxBytes(), ibbInstance);
        } else if (this.fileType === 'docx') {
          const { createEmptyDocxBytes } = await import(/* webpackChunkName: "empty-files" */ '@/utils/emptyFiles');
          handle = await api.createFileWithContent(this.req.handle, finalName, createEmptyDocxBytes(), ibbInstance);
        } else {
          // .txt (comportamiento original)
          if (this.$route.name === ROUTES.DRIVE) {
            handle = await api.createFile(this.req.handle, finalName, ibbLink);
          } else {
            handle = await api.createFile(this.req.handle, finalName);
          }
        }

        // Para .txt mantenemos el flujo original (abrir el editor directamente).
        // Para .xlsx / .docx cerramos el prompt sin más: el action listener del
        // SDK refresca la lista cuando el upload termina. El usuario pincha el
        // archivo manualmente cuando aparece.
        if (this.fileType === 'txt' && handle) {
          this.$router.push({ path: this.$route.path + '#' + handle });
        }
      } catch (e) {
        this.$showError(e);
      }

      this.$store.commit('closeHovers');
    },
  },
};
</script>
